import React from "react";
import { Card, Divider, Typography } from "antd";
import BinMaster from "../../../components/DispatchCentre/BinMaster/BinMaster";
import "../../../styles/global-ui.css";

const DS_MasterBinPage = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Master Bin
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            View and search grouped bin master details
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <BinMaster />
      </Card>
    </div>
  );
};

export default DS_MasterBinPage;